
export { PicturesIcon } from "./Pictures"
export { VideoIcon } from "./Video"